import React from 'react'
import * as Icons from 'react-feather'
import { MdFavoriteBorder, MdFavorite } from 'react-icons/md'
import { FiTag, FiChevronDown, FiChevronUp  } from 'react-icons/fi'
import { ReactComponent as CustomHome } from './homeicon.svg'
import styled from 'styled-components'
import theme, { ColorType, Scale } from '../../theming'
import { ReactComponent as Logout } from './logout-exit.svg'
import { ReactComponent as Close } from './closeicon.svg'
import { BiError } from 'react-icons/bi'

export interface Props {
    className?: string
    color?: ColorType
    name: string
    sizebyScale?: Scale
    size?: string
}

const Icon: React.FC<Props> = (props) => {
    const rIcons = { Home: CustomHome, MdFavorite, MdFavoriteBorder, FiTag, Logout, Close,
            BiError, FiChevronDown, FiChevronUp  }
    const { className = '', color = 'grayDark', name, sizebyScale = 'medium', size } = props
    let I = name in rIcons ? rIcons[name] : Icons[name]
    // Fallback to react-feather icons if custom SVG failed to load (SSR issue)
    if (!I && name === 'Close') I = Icons['X']
    if (!I && name === 'Home') I = Icons['Home']
    if (!I && name === 'Logout') I = Icons['LogOut']
    if (!I) {
        console.warn(`Icon "${name}" not found`)
        return null
    }
    return (
        <I
            className={className}
            size={size || theme.size[sizebyScale]}
            color={theme.color[color]}
        />
    )
}

const StyledIcon = styled(Icon)((props) => {
    return {
        fontWeight: 'bold',
        minWidth: theme.size[props.size || 'medium'],
    }
})

export default StyledIcon
